import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import "./PublicCTA.scss";

type PublicCTAProps = {
  setRegistrationModalOpen: () => void;
};

const PublicCTA = (props: PublicCTAProps): React.JSX.Element => {
  return (
    <div className="public-cta">
      <button
        className="nav-bar__nav-item--contact nav-bar__nav-item--contact--button"
        onClick={() => {
          props.setRegistrationModalOpen();
        }}
      >
        <FormattedMessage tagName="span" id="home-cta-register" />
      </button>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setRegistrationModalOpen: () => {
      dispatch.registrationFormModel.setRegistrationModalOpen();
    },
  };
}

export default connect(null, mapDispatchToProps)(PublicCTA) as any;
